import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=1c56e752&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"
import style1 from "./Master.vue?vue&type=style&index=1&id=1c56e752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56e752",
  null
  
)

export default component.exports